import { useRef, useState } from 'react'
import type { MouseEvent, PointerEvent } from 'react'

/**
 * Всплывашка-подсказка у значка: мышь открывает наведением, палец — нажатием,
 * клавиатура — фокусом (Tab). Клик мышью по уже открытой наведением подсказке её
 * не закрывает: `PopoverTrigger` переключает её на каждый клик, и пользователь мыши,
 * кликнувший по «i», видел, как подсказка пропадает.
 */
export const useHoverPopover = () => {
  const [open, setOpen] = useState(false)
  // Чем нажали: клик с клавиатуры (Enter/Space) приходит без `pointerdown`, а фокус
  // от нажатия мышью или пальцем открывать подсказку не должен — это делают
  // наведение и сам клик.
  const pressedWith = useRef<string | null>(null)
  const triggerProps = {
    onPointerEnter: (e: PointerEvent) => {
      if (e.pointerType === 'mouse') setOpen(true)
    },
    onPointerLeave: (e: PointerEvent) => {
      if (e.pointerType === 'mouse') setOpen(false)
    },
    onPointerDown: (e: PointerEvent) => {
      pressedWith.current = e.pointerType
    },
    onClick: (e: MouseEvent) => {
      const byMouse = pressedWith.current === 'mouse'
      pressedWith.current = null
      // `preventDefault` отменяет переключение у `PopoverTrigger`: Radix его проверяет.
      if (byMouse && open) e.preventDefault()
    },
    onFocus: () => {
      if (pressedWith.current === null) setOpen(true)
    },
    onBlur: () => setOpen(false),
  }
  return { open, setOpen, triggerProps }
}
